<app-logo-header></app-logo-header>
<section class="section">
  <div class="container">
    <h1 class="mt-5">
      Search Results : {{products?.length}} Items
    </h1>
    <div class="products-block border-0" *ngIf="products?.length">
      <div *ngFor="let product of products">
        <div class="products-container">
          <a routerLink="/{{product.code}}">
            <div class="products-container-frame">
              <div class="products-image">
                <img src="{{ product.image ? product.image : 'assets/images/placeholders/invoice.jpg'}}" alt="">
              </div>
              <img class='products-event' src="/assets/img/event.png" alt="">
              <p class="event">{{ product.productType }}</p>
              <div class="products-prise" *ngIf="product.productPrice">
                <div class="products-prise-cirkl">
                  <p>
                    {{ product.currency + product.productPrice }}
                  </p>
                </div>
              </div>
              <p class="social-media">
                {{ product.productName }}
              </p>
            </div>
          </a>
          <button (click)="openProduct(product.code)" class="pointer">Buy</button>
        </div>
      </div>
    </div>

  </div>
</section>

<app-footer></app-footer>
